import './_collection-promobar.scss';

export default () => {};
